import { useMutation } from '@tanstack/react-query';

import { PREFIX_URL } from '@/src/api/config';
import { axios } from '@/src/lib/axios/axios';
import { MutationConfig, queryClient } from '@/src/lib/react-query/react-query';
import { generateRoutePath } from '@/src/routes';

import { UpdateEmailEntryResponse } from './config';
import { acivityLogsKeys } from './getActivityLogs';

import { entryActionCustomValidateOptions } from '../../../../api/inbox';
// const url = `${PREFIX_URL}/v01/inboxThread/tagWorkstream`;
const url = `${PREFIX_URL}/inbox-threads/:inboxEntryId/emails/:emailId`;

export type TagEmailWorkstreamDTO = {
  projectId: string;
  inboxEntryId: number;
  emailId: number;
  workstreamIds: number[];
};

export const tagEmailWorkstream = ({
  projectId,
  inboxEntryId,
  emailId,
  workstreamIds,
}: TagEmailWorkstreamDTO): Promise<UpdateEmailEntryResponse> => {
  return axios.put(
    generateRoutePath(url, { projectId, inboxEntryId, emailId }),
    {
      'workstream-ids': workstreamIds,
    },
    {
      ...entryActionCustomValidateOptions,
    }
  );
};

type useTagEmailWorkstreamOptions = {
  projectId: string;
  inboxEntryId: number;
  emailId: number;
  config?: MutationConfig<typeof tagEmailWorkstream>;
};

export const useTagEmailWorkstream = ({
  projectId,
  inboxEntryId,
  emailId,
  config,
}: useTagEmailWorkstreamOptions) => {
  return useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries([
        ...acivityLogsKeys.detail({ projectId, emailId, inboxEntryId }),
      ]);
      // Moved to component because response data has no workstream ids
      // queryClient.setQueriesData([...emailEntriesKeys.lists(projectId)], (prev: any) => {
      //   return {
      //     ...prev,
      //     pages: prev.pages.map((page) => {
      //       return {
      //         ...page,
      //         data: {
      //           ...page.data,
      //           emails: page.data.emails.map((emailEntry) => {
      //             if (emailEntry.id === emailId) {
      //               return {
      //                 ...emailEntry,
      //                 workstreams: data.data.workstreams,
      //                 modifiedDate: data.data.modified.date,
      //                 modifiedBy: data.data.modified.name,
      //               };
      //             }
      //             return emailEntry;
      //           }),
      //         },
      //       };
      //     }),
      //   };
      // });
      // if (
      //   !queryClient.getQueryData([
      //     ...emailEntryKeys.detail({ emailId, inboxEntryId, projectId }),
      //   ])
      // ) {
      //   return;
      // }
      // queryClient.setQueryData(
      //   [...emailEntryKeys.detail({ emailId, inboxEntryId, projectId })],
      //   (prev: any) => {
      //     return {
      //       ...prev,
      //       data: {
      //         ...prev.data,
      //         workstreams: data.data.workstreams,
      //         modifiedDate: data.data.modified.date,
      //         modifiedBy: data.data.modified.name,
      //       },
      //     };
      //   }
      // );
    },
    ...config,
    mutationFn: tagEmailWorkstream,
  });
};
